import React, { useEffect, useState } from "react"

const Table = ({ className, headerMap, headers, data, rowHover, showFilters=false }) => {
    className = `table ${className ? className : ""}`

    const [filteredData, setFilteredData] = useState(null)
    const [filters, setFilters] = useState({})

    const handleFilterEffect = () => {
        const isFilterApplied = !!Object.keys(filters).length && Object.values(filters).reduce((acc, value) => !!acc && !!value, true)
        if(!isFilterApplied) return setFilteredData(null);

        let temp = data;

        for(let filter in filters){
            
            temp = temp.filter(v => {
                let value = v[filter];
                if(React.isValidElement(value)){
                    value = value.props.children
                }
                return value.toString().toLowerCase().indexOf(filters[filter].toLowerCase()) != -1
            })
        }
        setFilteredData([...temp])
    }

    useEffect(handleFilterEffect, [filters, data])

    const handleChange = (e) => {
        const {name, value} = e.target;

        setFilters({
            [name]: value
        })
    }

    return <div className={className}>
        <table>
            {
                headers && <thead>
                    <tr>
                        {
                            headers.map((key, i) => {
                                if (!headerMap) return <th key={key}>{key}</th>
                                return <th key={key}>{headerMap[key].label}</th>
                            })
                        }
                    </tr>
                    {
                        showFilters &&
                        <tr>
                            {
                                headers.map((key, i) => {
                                    if (headerMap && !headerMap[key].filter) return <td></td>;

                                    if(!headerMap) return <td key={key}>
                                        <input name={key} value={filters[key]} onChange={handleChange}/>
                                    </td>


                                    return <td>
                                        <input name={key} value={filters[key]} onChange={handleChange}/>
                                    </td>
                                })
                            }
                        </tr>
                    }
                </thead>
            }

            {
                data && <tbody>
                    {
                        (filteredData ?? data).map(v => {
                            return <tr key={v._id} className={rowHover? `table--hover--${rowHover}` : ""}>{
                                headers ?
                                    headers.map(key => {
                                        return <td key={key}>{v[key]}</td>
                                    })
                                    :
                                    Object.keys(v).map(key => {
                                        return <td key={key}>{v[key]}</td>
                                    })
                            }</tr>
                        })
                    }
                </tbody>
            }
        </table>
    </div>
    
}

export default Table